import React, { Fragment, useContext as UseContext, useEffect as UseEffect, useState as UseState } from 'react';
import { useParams } from "react-router";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Grid, 
        Container,
          Card, 
          CardContent,
          Button, 
          TextField, 
          List, 
          ListItem,
          Dialog,
          DialogActions,
        DialogContent,
        DialogTitle
} from '@material-ui/core';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import DialogContentText from '@material-ui/core/DialogContentText';
import imgLogo from "../../../assets/images/iunir_logo_circle.png"

import { NavLink as RouterLink } from 'react-router-dom';
import validator from 'validator';

import { useHistory  } from "react-router-dom";
import { AuthContext } from "../../Authentication/AuthComponent";
import usuariosService from "../../../services/usuarios.service";

import CodeRoundedIcon from '@mui/icons-material/CodeRounded';
import AddTaskIcon from '@mui/icons-material/AddTask';
import CheckIcon from '@mui/icons-material/Check';
import Cookies from 'universal-cookie';

const onSubmitCambiar = (e) => {
e.preventDefault();
const new_password = e.target.elements.new_password.value;
const new_password2 = e.target.elements.new_password2.value;
const val_uid = e.target.elements.uid.value;
const val_token= e.target.elements.token.value;
if (val_uid =='' || val_token == ''){
  toast.error("El enlace para reestablecer la contraseña no es válido, intente nuevamente.", {autoClose: 10000});
}
else {
if (new_password !== new_password2){
toast.error("Las contraseñas ingresadas no coinciden", {autoClose: 10000});
} else {
if (validator.isStrongPassword(new_password, {
minLength: 8, minLowercase: 1,
minUppercase: 1, minNumbers: 1, minSymbols: 1
})) {
const cookies = new Cookies();
cookies.remove('sessionid', { path: '/' });
usuariosService.ResetearClave(new_password,new_password2,val_uid, val_token).then(resultado => {
if (resultado === "OK"){     
  toast.success("La nueva contraseña ha sido registrada correctamente. La misma tendrá validez a partir del próximo inicio de sesión ",{
    onClose: () => {
      window.location.href = 'autogestion/#/Login'
    }, autoClose: 5000});
} else {  
    toast.error("No se pudo cambiar lo contraseña actual, intente solicitar el cambio de contraseña nuevamente y si persiste el error contacte a soporte",
    {
      onClose: () => {
        window.location.href = '/autogestion/#/Login'
      }, autoClose: 5000});
  }
}); 
} else {
toast.error("No se pudo cambiar lo contraseña porque no cumple las condiciones de contraseña segura", {autoClose: 10000});
}

}
}
};



const ResetPasswordComponent = () => {    
  const { uid } = useParams();
  const { token } = useParams();

  const [open1, setOpen1] = React.useState(false);

const handleClickOpen1 = () => {
setOpen1(true);
};

const handleClose1 = () => {
setOpen1(false);
};
return (
  <Fragment>
   
    <ToastContainer />
    <div className="app-wrapper min-vh-100">
      <div className="app-main flex-column">
        <div className="app-content p-0">
          <div className="app-content--inner d-flex align-items-center">
            <div className="flex-grow-1 w-100 d-flex justify-content-center">
            <Container maxWidth="lg" className="d-flex justify-content-center">
                  <Grid container spacing={5} className="d-flex justify-content-center">
                    <Grid
                      item
                      xs={12}
                      lg={7}
                      className="d-flex flex-column align-items-center">                                                      
                      <Card className="m-0 w-100 p-0 border-0">
                      <div className="card-header pr-2">
                      <div className="text-center text-black-50 mb-3">
                             <img
                                src={imgLogo}
                                className="center"
                                alt=""
                              />
                          </div>       
                          <div className="card-header--title py-2 font-size-lg font-weight-bold text-center">
                              SISTEMA DE AUTOGESTIÓN 
                          </div>
                          </div>                                                  
                        <CardContent className="p-3">
                        <form onSubmit={onSubmitCambiar}>
                            <input name="uid" id="uid" value={uid} type="hidden" />
                            <input name="token" id="token" value={token} type="hidden" />
                            <div className="card-header pr-2">
                                <div className="card-header--title py-2 font-size-lg font-weight-bold">
                                    Recuperar contraseña de acceso
                                </div>
                            </div>
                            <div className="card-body">
                            <Grid container spacing={4} alignItems="stretch">
                                <Grid item xs={12} lg={6} >
                                <div className="mb-3">
                                            <TextField
                                              variant="outlined"
                                              label="Contraseña nueva"
                                              fullWidth
                                              placeholder="Ingrese la contraseña nueva"
                                              type="password"
                                              id="new_password"
                                              required
                                            />
                                </div>
                                </Grid>
                                <Grid item xs={12} lg={6} >             
                                <div className="mb-3">
                                            <TextField
                                              variant="outlined"
                                              label="Reingresar la contraseña"
                                              fullWidth
                                              placeholder="Reingrese la contraseña nueva"
                                              type="password"
                                              id="new_password2"
                                              required
                                            />
                                </div>   
                                </Grid>
                                </Grid>
                                <Grid container spacing={4} alignItems="stretch">
                                <Grid item xs={12} lg={8} >
                                <Button
                                                        className="m-2"        
                                                        color="primary"
                                                        onClick={handleClickOpen1}> <AddTaskIcon />
                                                        Condiciones de contraseña segura
                                                      </Button>
                                                      <Dialog
                                                        open={open1}
                                                        onClose={handleClose1}
                                                        aria-labelledby="form-dialog-title">
                                                        <DialogTitle id="form-dialog-title">¡Atención!</DialogTitle>
                                                        <DialogContent>
                                                          <DialogContentText>
                                                          Para cambiar la contraseña, deberás respetar las siguientes condiciones.
                                                          </DialogContentText>
                                                          <List>
                                                            <ListItem>
                                                                    <ListItemIcon>
                                                                      <CheckIcon />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                      secondary="La misma deberá tener al menos 8 caracteres"                   
                                                                    />
                                                                </ListItem>
                                                                <ListItem>
                                                                    <ListItemIcon>
                                                                      <CheckIcon />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                      secondary="Estos caracteres deberán estar compuestos por al menos un número, una letra mayúscula, una letra minúscula y un símbolo"                   
                                                                    />
                                                                </ListItem>
                                                                <ListItem>
                                                                    <ListItemIcon>
                                                                      <CheckIcon />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                      secondary="No se admite usar la contraseña actual o la anterior"                   
                                                                    />
                                                                </ListItem>
                                                            </List>
                                                            <DialogContentText>
                                                            Cualquier consulta, comuníquese con su Facultad
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>                                         
                                                          <Button onClick={handleClose1} color="primary">
                                                            Cerrar
                                                          </Button>
                                                        </DialogActions>
                                                      </Dialog>
                                
                                </Grid>
                                </Grid>             
                            </div>
                            <div className="card-footer pr-2">
                          
                                                          <Button type="submit" color="primary">
                                                          Cambiar
                                                          </Button>
                                                          <Button  
                                                            component={RouterLink}
                                                            to="/" 
                                                            color="primary"
                                                            >
                                                            Cancelar
                                                          </Button>
                                                      
                            </div>
                            </form>

                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Container>
            </div>             
          </div>
        </div>
      </div>
    </div>
  </Fragment>
);
};
export default ResetPasswordComponent;